import { createSlice } from '@reduxjs/toolkit';
import { GLOBALSETTINGS } from '../data/constants';

interface RecentViewedSliceState {
  triggerFile: number; 
  triggerFolder: number;
}

const initialState: RecentViewedSliceState = {
  triggerFile: GLOBALSETTINGS.DEFAULT_STATE,
  triggerFolder: GLOBALSETTINGS.DEFAULT_STATE,
};

const recentViewedSlice = createSlice({
  name: 'RecentViewed',
  initialState,
  reducers: {
    setRecentViewedFolder(state) {
      state.triggerFolder += 1;
    },
    clearRecentViewedFolder(state) {
      state.triggerFolder = -1;
    },
    setRecentViewedFile(state) {
      state.triggerFile += 1;
    },
    clearRecentViewedFile(state) {
      state.triggerFile = -1;
    },
  },
});

export const { setRecentViewedFolder, clearRecentViewedFolder, setRecentViewedFile, clearRecentViewedFile} = recentViewedSlice.actions;

export default recentViewedSlice.reducer;
